import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  SwiperOptions
} from 'swiper';
import Controler from '../base/Controler';

class SliderControler extends Controler {
  constructor() {
    super();
    this.init();
  }

  init(): void {
    this.selectElements('.js-swiper').forEach(el => {
      const config = el.dataset.swiperConfig || 'default';
      const swiper = new Swiper(el, this.config(config, el));
    });
  }

  private config(settings: string, el: HTMLElement): SwiperOptions {
    const parent = el.parentElement;
    let config: SwiperOptions = {
      speed: 600,
      navigation: {
        nextEl: parent.querySelector('.swiper__button--next') as HTMLElement,
        prevEl: parent.querySelector('.swiper__button--prev') as HTMLElement
      }
    };

    if (settings === 'default') {
      Swiper.use([Pagination, Navigation, Autoplay]);
      config = {
        ...config,
        loop: false,
        spaceBetween: 40,
        pagination: {
          el: '.swiper__pagination',
          clickable: true
        },
        // autoplay: {
        //   delay: 5000
        // },
        breakpoints: {
          767: {
            allowTouchMove: false
          }
        }
      };
    }

    if (settings === 'shop') {
      Swiper.use([Navigation, Pagination]);
      config = {
        ...config,
        loop: false,
        spaceBetween: 40,
        pagination: {
          el: '.swiper__pagination',
          clickable: true
        },
        autoHeight: true,
        on: {
          breakpoint(swiper) {
            setTimeout(() => {
              swiper.update();
            }, 0);
          }
        },
        breakpoints: {
          767: {
            slidesPerView: 'auto',
            spaceBetween: 24,
            allowTouchMove: false,
            autoHeight: false
          }
        }
      };
    }

    return config;
  }
}

export default SliderControler;
